import { Text, View } from '@components/primitives';
import { PWA_REFFERAL_LINK } from '@root/constants';
import colors from '@theme/colors';
import { scale } from '@utils/normalize';
import { numberWithDots } from '@utils/utils';
import React from 'react';
import { Linking } from 'react-native';
import styles from './styles';

interface ReferralTnCProps {
  tncItem?: string;
  index?: number;
  referrerAmt?: number;
  refereeAmt?: number;
}

const shouldShowLink = (index: number): React.ReactElement | null =>
  index === 5 ? (
    <Text
      variant="sm-normal"
      style={{ color: colors.secondary.orchid }}
      onPress={() => Linking.openURL(PWA_REFFERAL_LINK)}>
      {PWA_REFFERAL_LINK}
    </Text>
  ) : null;

const ReferralTnC: React.FC<ReferralTnCProps> = ({ tncItem = '', index = 0, referrerAmt = 0, refereeAmt = 0 }) => {
  const displayText = (): string => {
    let text = tncItem.replace('$$referrerRewardAmount$$', numberWithDots(referrerAmt));
    text = text.replace('$$refereeRewardAmount$$', numberWithDots(refereeAmt));
    return text;
  };

  return (
    <View style={styles.tncContainer}>
      <Text style={styles.tncNumberStyle}>{index + 1}</Text>
      <Text variant="sm-normal" style={[{ marginHorizontal: scale(10) }, { paddingRight: scale(20) }]}>
        {displayText()}
        {shouldShowLink(index)}
      </Text>
    </View>
  );
};

export default ReferralTnC;
